import { Controller } from '@hotwired/stimulus';
import { getParams } from '../helpers';

export default class extends Controller {
    static values = {
        redirect: Boolean,
        removeFirst: Boolean,
        changeSubmit: String,
    }
    connect() {
        const selectContainer = this.element;
        this.mainClass = this.element.classList[0] ? this.element.classList[0] : 'input-select';
        this.selectInput = selectContainer.getElementsByTagName("select")[0];
        this.emptyOption = null;
        this.selectItemsContainer = document.createElement("div");
        this.selectedItemContainer = document.createElement("div");
        this.selectLength = this.selectInput.length;

        this.selectOptions = [];

        this.selectedItemContainer.setAttribute("class", `${this.mainClass}__selected`);
        this.selectedItemContainer.innerHTML = this.selectInput.options[this.selectInput.selectedIndex].innerHTML;

        selectContainer.appendChild(this.selectedItemContainer);

        this.selectItemsContainer.setAttribute("class", `${this.mainClass}__items d-none`);

        for (let a = 0; a < this.selectLength; a++) {
            const selectOption = document.createElement("div");
            selectOption.innerHTML = this.selectInput.options[a].innerHTML;
            selectOption.dataset.value = this.selectInput.options[a].value;

            if (this.selectInput.options[a].hidden
                || !this.selectInput.options[a].value
                || this.selectInput.options[a].value === '') {
                this.emptyOption = selectOption;
                continue;
            }

            this.selectOptions.push(selectOption);

            if (this.selectInput.value) {
                if (this.selectInput.options[a].value === this.selectInput.value) {
                    this.setSelected(a, selectOption);
                }
            }

            selectOption.addEventListener("click", (e) => {
                for (let b = 0; b < this.selectLength; b++) {
                    if (this.selectInput.options[b].value === e.currentTarget.dataset.value) {
                        this.setSelected(b, e.target);
                        break;
                    }
                }

                this.toggleSelectOptions(this.selectedItemContainer);
                this.selectInput.dispatchEvent(new Event("change"));
            });

            this.selectItemsContainer.appendChild(selectOption);
        }

        selectContainer.appendChild(this.selectItemsContainer);

        this.selectedItemContainer.addEventListener("click", (e) => {
            if (!this.selectInput.disabled && !this.selectInput.hasAttribute('readonly')) {
                e.stopPropagation();
                this.toggleSelectOptions();
            }
        });

        document.addEventListener("click", (e) => {
            if (!this.element.contains(e.target)) {
                this.hideSelectOptions();
            }
        });

        if (this.changeSubmitValue) {
            this.selectInput.addEventListener("change", (e) => {
                axios.post(this.changeSubmitValue, { [this.selectInput.name]: this.selectInput.value });
            });
        }
    }

    toggleSelectOptions() {
        document.querySelectorAll(`.${this.mainClass}__items`).forEach((el) => {
            if (el !== this.selectItemsContainer) {
                el.classList.add("d-none");
            }
        });

        document.querySelectorAll(`.${this.mainClass}__selected`).forEach((el) => {
            if (el !== this.selectedItemContainer) {
                el.classList.remove(`${this.mainClass}__active`);
            }
        });

        this.selectItemsContainer.classList.toggle("d-none");
        this.selectedItemContainer.classList.toggle(`${this.mainClass}__active`);
    }

    hideSelectOptions() {
        this.selectItemsContainer.classList.add("d-none");
        this.selectedItemContainer.classList.remove(`${this.mainClass}__active`);
    }

    setSelected(selectIndex, el) {
        this.selectInput.selectedIndex = selectIndex;
        this.selectedItemContainer.innerHTML = el.innerHTML;
        const selectedItems = this.selectItemsContainer.getElementsByClassName(`${this.mainClass}__selected-item`);
        const selectedItemsLength = selectedItems.length;

        if (this.element.querySelectorAll(`.${this.mainClass}__items div`).length === 1) {
            this.element.querySelector(`.${this.mainClass}__items`).classList.add('exhausted');
        }

        for (let c = 0; c < selectedItemsLength; c++) {
            selectedItems[c].classList.remove(`${this.mainClass}__selected-item`);
        }

        el.classList.add(`${this.mainClass}__selected-item`);
    }

    refreshWithValue() {
        const url = new URL(window.location);
        url.searchParams.set(this.selectInput.name, this.selectInput.value)
        url.searchParams.set('paged', '1')
        window.location.href = url.href;
    }

    redirectToValue() {
        window.location.href = this.selectInput.value;
    }
}
